import React from 'react'
import 'react-h5-audio-player/lib/styles.css';
import './section-radio-show-and-forum-podcast.scss'
import SinglePodcast from '../single-podcast/single-podcast';

const SectionRadioShowAndForumPodcast = ({ contentInfo }) => {

    return (
        <section className="f-m-radio-show-and-forum-podcast">
            <div className="f-m-radio-show-and-forum-podcast__content">
                <div className="f-m-radio-show-and-forum-podcast__main-title">{contentInfo.tituloGeneral}</div>
                <div className="f-m-radio-show-and-forum-podcast__list">
                    {(contentInfo.listaContenidos && contentInfo.listaContenidos.length > 0) &&
                        contentInfo.listaContenidos.map((info, index) => {
                            return (
                                <SinglePodcast info={info} key={index} />
                            )
                        })
                    }
                </div>

            </div>
        </section>
    )
}

export default SectionRadioShowAndForumPodcast
